import { FormContainer } from 'react-hook-form-mui';
import { useWizardWithData } from '../../../../../../../../../core/hooks/WizardWithData';
import { WizardActionsRHF } from '../../../wizard/actions/WizardActions';
import { GipAodRuleWizardValues } from '../types';
import { GipExportConditionsFields } from './GipExportConditionsFields';

export const AodGipExportConditionsForm = () => {
  const wizard = useWizardWithData<GipAodRuleWizardValues>();

  const defaultValues = {
    enableEfficiency: true,
    minEfficiency: 100,
  };

  return (
    <FormContainer
      defaultValues={wizard.data.exportConditions ?? defaultValues}
      onSuccess={(data) => {
        wizard.setData({
          exportConditions: data,
        });
      }}
    >
      <GipExportConditionsFields />
      <WizardActionsRHF />
    </FormContainer>
  );
};
